import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Home, LayoutDashboard, CalendarClock, MessageCircle, Menu, X, LogOut, Users2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Só os 4 itens de uso mais frequente viram abas fixas (padrão de app iOS:
// poucas abas, o resto fica atrás de "Mais"). O "Mais" abre um sheet com
// o restante do menu, pra não precisar recriar toda a navegação aqui.
const TABS = [
  { to: "/home", label: "Início", icon: Home },
  { to: "/painel", label: "Painel", icon: LayoutDashboard },
  { to: "/agendamento", label: "Agenda", icon: CalendarClock },
  { to: "/whatsapp", label: "WhatsApp", icon: MessageCircle },
];

const MORE_LINKS = [
  { to: "/historico", label: "Histórico" },
  { to: "/grupos", label: "Grupos & Páginas" },
  { to: "/extensao", label: "Extensão" },
  { to: "/agentes-vivo", label: "Agentes de Venda Vivo" },
  { to: "/prospecto", label: "Estratégias de Vendas" },
  { to: "/meta-ads", label: "Meta Ads" },
  { to: "/utms", label: "UTMs" },
  { to: "/integracao-claude", label: "Integração Claude" },
  { to: "/afiliados", label: "Afiliados" },
  { to: "/planos", label: "Planos" },
];

export default function IOSTabBar() {
  const [sheetOpen, setSheetOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = () => {
    setSheetOpen(false);
    logout();
    navigate("/login");
  };

  // Mesma regra da Sidebar: "Pipeline de Empresa" só aparece pra contas
  // liberadas pro beta de Empresa (user.is_company) — sem essa checagem o
  // link ficava de fora da tab bar inteira, mesmo pra quem tem acesso.
  const moreLinks = user?.is_company
    ? [{ to: "/empresa", label: "Pipeline de Empresa", icon: Users2 }, ...MORE_LINKS]
    : MORE_LINKS;

  return (
    <>
      <nav className="ios-tabbar" role="navigation" aria-label="Navegação principal">
        {TABS.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) => "ios-tab" + (isActive ? " ios-tab-active" : "")}
          >
            <Icon size={24} strokeWidth={2} />
            <span>{label}</span>
          </NavLink>
        ))}
        <button
          type="button"
          className="ios-tab"
          onClick={() => setSheetOpen(true)}
          aria-label="Mais opções"
        >
          <Menu size={24} strokeWidth={2} />
          <span>Mais</span>
        </button>
      </nav>

      {sheetOpen && (
        <div className="ios-sheet-backdrop" onClick={() => setSheetOpen(false)}>
          <div className="ios-sheet" onClick={(e) => e.stopPropagation()}>
            <div className="ios-sheet-handle" />
            <div className="ios-sheet-header">
              <span>Mais opções</span>
              <button type="button" onClick={() => setSheetOpen(false)} aria-label="Fechar">
                <X size={20} />
              </button>
            </div>
            <div className="ios-sheet-list">
              {moreLinks.map(({ to, label, icon: Icon }) => (
                <NavLink
                  key={to}
                  to={to}
                  className="ios-sheet-item"
                  onClick={() => setSheetOpen(false)}
                >
                  {Icon && <Icon size={16} className="ios-sheet-item-icon" />}
                  {label}
                </NavLink>
              ))}
              <button
                type="button"
                className="ios-sheet-item ios-sheet-item-danger"
                onClick={doLogout}
                data-testid="ios-tabbar-logout-button"
              >
                <LogOut size={16} />
                Sair
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
